module.exports = __webpack_public_path__ + "static/media/icon-calendar-month.3385b1af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-calendar-month.svg
// module id = 683
// module chunks = 0